import React from 'react';

function Mobile() {
  return (
    <div className="mt-3 jumbotron">
      <p>Currently, Installer App is not available for mobile devices.</p>
    </div>
  );
}

export default Mobile;
